import PromotionFilter from './promotions';
import DisplayOverridesFilter from './displayOverrides';

const Filter = { PromotionFilter, DisplayOverridesFilter };

export default Filter;
